import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import StreamWebService from '../classes/StreamWebService';

const CategoryTiles = (props) => {
  const scrollRef = useRef(null);
  const { onClick } = props;
  const sWeb = new StreamWebService()

  const [activeCategory, setactiveCategory] = useState("All")
  const [categories, setCategories] = useState(["All"])


  const fetchCategories = () => {
    sWeb.getCategories().then(res => setCategories([...categories, ...res.data]))
  }

  const onButtonClick = (category) => {
    var value = category
    setactiveCategory(value)
    if (category == "All") {
      value = null
    }
    if (onClick) {
      onClick(value)
    }
    console.log(category)
  }



  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      scrollRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };



  useEffect(() => {
    fetchCategories()


  }, [])


  return (
    <div className="relative  w-full">
      <div className="flex items-center">
        <button
          onClick={() => scroll('left')}
          className=" left-0 z-10 p-2 bg-black/60 text-white hover:bg-black/80 transition-colors"
          aria-label="Scroll left"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>

        <div
          ref={scrollRef}
          className="flex overflow-x-auto scrollbar-hide py-3 px-4 space-x-2 scroll-smooth"
          style={{
            msOverflowStyle: 'none',
            scrollbarWidth: 'none'
          }}
        >
          {categories.map((category, index) => (
            <button
              onClick={_ => onButtonClick(category)}
              key={index}
              className={`
                whitespace-nowrap px-4 py-1.5 rounded-lg text-sm font-medium
                transition-colors duration-200 
                ${activeCategory === category
                  ? 'bg-white text-black hover:bg-gray-200'
                  : 'bg-gray-600 text-white hover:bg-gray-500'
                }
              `}
            >
              {category}
            </button>
          ))}
        </div>

        <button
          onClick={() => scroll('right')}
          className=" right-0 z-10 p-2 bg-black/60 text-white hover:bg-black/80 transition-colors"
          aria-label="Scroll right"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

// Add custom CSS to hide scrollbar
const styles = `
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

// Insert styles into document head
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default CategoryTiles;